/* SAMANSA Shop — promo display
   When a visitor arrives via /discount/CODE?redirect=/?promo=SLUG,
   we persist the promo slug in localStorage and rewrite product
   prices + add a badge while the session is active.
   The actual discount is applied by Shopify at checkout via its
   own session cookie — this is purely display. Keep the rate here
   in sync with the corresponding Shopify discount setting. */
(function () {
  'use strict';

  var PROMO_MAP = {
    friend5:   { rate: 0.10, label: '10%OFF' },
    samansa10: { rate: 0.10, label: '10%OFF' }
  };

  var STORAGE_KEY = 'samansa_promo';
  var COOKIE_DAYS = 30;

  function setCookie(name, value, days) {
    try {
      var d = new Date();
      d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
      document.cookie = name + '=' + encodeURIComponent(value) +
        ';expires=' + d.toUTCString() +
        ';path=/;SameSite=Lax';
    } catch (e) {}
  }

  function getCookie(name) {
    try {
      var pairs = document.cookie.split(';');
      for (var i = 0; i < pairs.length; i++) {
        var kv = pairs[i].trim().split('=');
        if (kv[0] === name) return decodeURIComponent(kv.slice(1).join('='));
      }
    } catch (e) {}
    return null;
  }

  function readUrlPromo() {
    var url = new URL(window.location.href);
    var p = url.searchParams.get('promo');
    var fromQuery = !!p;
    var fromHash = false;
    // Also accept hash fragment: /#promo=SLUG  (more robust through in-app
    // webviews that mishandle URLs with two '?' characters)
    if (!p && url.hash) {
      var hashParams = new URLSearchParams(url.hash.replace(/^#/, ''));
      var hp = hashParams.get('promo');
      if (hp) { p = hp; fromHash = true; }
    }
    if (!p) return null;
    if (fromQuery) url.searchParams.delete('promo');
    if (fromHash) url.hash = '';
    var clean = url.pathname + (url.searchParams.toString() ? '?' + url.searchParams.toString() : '') + url.hash;
    try { history.replaceState({}, '', clean); } catch (e) {}
    return p.toLowerCase();
  }

  function getActivePromo() {
    var fromUrl = readUrlPromo();
    if (fromUrl && PROMO_MAP[fromUrl]) {
      setCookie(STORAGE_KEY, fromUrl, COOKIE_DAYS);
      try { localStorage.setItem(STORAGE_KEY, fromUrl); } catch (e) {}
      return PROMO_MAP[fromUrl];
    }
    var stored = getCookie(STORAGE_KEY);
    if (!stored) {
      // Backward-compat: migrate from localStorage if it has a value
      try { stored = localStorage.getItem(STORAGE_KEY); } catch (e) { stored = null; }
      if (stored && PROMO_MAP[stored]) setCookie(STORAGE_KEY, stored, COOKIE_DAYS);
    }
    if (stored && PROMO_MAP[stored]) return PROMO_MAP[stored];
    return null;
  }

  function formatYen(amount) {
    return '¥' + Math.round(amount).toLocaleString('en-US');
  }

  function parsePrice(text) {
    var match = text.match(/¥\s*([\d,]+)/);
    if (!match) return null;
    var n = parseInt(match[1].replace(/,/g, ''), 10);
    return (n && !isNaN(n)) ? n : null;
  }

  // Replace a single-price element's text with: now + strikethrough was
  function rewritePriceEl(el, original, conf, opts) {
    opts = opts || {};
    var discounted = original * (1 - conf.rate);
    var nowSpan = document.createElement('span');
    nowSpan.className = (opts.nowClass || 'promo-now');
    nowSpan.textContent = formatYen(discounted) + (opts.suffix || '');

    var wasSpan = document.createElement('span');
    wasSpan.className = (opts.wasClass || 'promo-was');
    wasSpan.textContent = formatYen(original) + (opts.suffix || '');

    el.textContent = '';
    el.appendChild(nowSpan);
    el.appendChild(document.createTextNode(' '));
    el.appendChild(wasSpan);
  }

  // Insert promo badge inside an existing or new badges container
  function insertBadge(container, parent, conf, badgeClass) {
    if (container.querySelector('.' + badgeClass + '--promo-marker')) return;
    if (!container.parentNode) parent.prepend(container);
    var span = document.createElement('span');
    span.className = badgeClass + ' ' + badgeClass + '--promo ' + badgeClass + '--promo-marker';
    span.textContent = conf.label;
    container.prepend(span);
  }

  // ──────── Collection card ────────
  function applyToCard(card, conf) {
    if (card.dataset.promoApplied === '1') return;

    var info = card.querySelector('.shop-card-info');
    if (!info) return;

    var priceEl = card.querySelector('.shop-card-price');
    if (!priceEl) return;
    if (priceEl.querySelector('.shop-card-price--sold')) return;

    var raw = priceEl.textContent.trim();
    var original = parsePrice(raw);
    if (!original) return;
    var hasRange = raw.indexOf('〜') !== -1;

    card.dataset.promoApplied = '1';

    var badges = info.querySelector('.shop-card-badges');
    if (!badges) {
      badges = document.createElement('div');
      badges.className = 'shop-card-badges';
      info.prepend(badges);
    }
    insertBadge(badges, info, conf, 'shop-card-badge');

    rewritePriceEl(priceEl, original, conf, {
      nowClass: 'shop-card-price--now',
      wasClass: 'shop-card-price--was',
      suffix: hasRange ? '〜' : ''
    });
  }

  // ──────── Product detail page ────────
  function applyToProductPage(conf) {
    var info = document.querySelector('.prod-info-inner');
    if (!info) return;

    // Badge
    var badges = info.querySelector('.prod-badges');
    if (!badges) {
      badges = document.createElement('div');
      badges.className = 'prod-badges';
      info.prepend(badges);
    }
    insertBadge(badges, info, conf, 'prod-badge');

    // Price (with variant-change watch — samansa-product.js may rewrite #prod-price-amount)
    var priceEl = document.getElementById('prod-price-amount');
    if (!priceEl) return;

    function rewrite() {
      if (priceEl.dataset.promoApplied === '1') return;
      var raw = priceEl.textContent.trim();
      var original = parsePrice(raw);
      if (!original) return;
      priceEl.dataset.promoApplied = '1';
      rewritePriceEl(priceEl, original, conf, {
        nowClass: 'prod-price--now',
        wasClass: 'prod-price--was'
      });
    }
    rewrite();

    if (!priceEl.dataset.promoObserving) {
      priceEl.dataset.promoObserving = '1';
      var mo = new MutationObserver(function () {
        // External rewrite (variant change) wipes our spans — re-apply
        if (!priceEl.querySelector('.prod-price--now')) {
          priceEl.dataset.promoApplied = '';
          rewrite();
        }
      });
      mo.observe(priceEl, { childList: true, characterData: true, subtree: true });
    }
  }

  // ──────── Cart line item ────────
  function applyToCartItem(item, conf) {
    if (item.dataset.promoApplied === '1') return;
    var priceEl = item.querySelector('.cart-item-price');
    if (!priceEl) return;
    var raw = priceEl.textContent.trim();
    var original = parsePrice(raw);
    if (!original) return;

    item.dataset.promoApplied = '1';

    var main = item.querySelector('.cart-item-main');
    if (main) {
      var badges = main.querySelector('.cart-item-badges');
      if (!badges) {
        badges = document.createElement('div');
        badges.className = 'cart-item-badges';
        // place badges before the name link
        var name = main.querySelector('.cart-item-name');
        if (name) main.insertBefore(badges, name); else main.prepend(badges);
      }
      insertBadge(badges, main, conf, 'cart-item-badge');
    }

    rewritePriceEl(priceEl, original, conf, {
      nowClass: 'cart-item-price--now',
      wasClass: 'cart-item-price--was'
    });
  }

  function run() {
    var conf = getActivePromo();
    if (!conf) return;
    document.documentElement.classList.add('promo-active');

    document.querySelectorAll('.shop-card').forEach(function (c) { applyToCard(c, conf); });
    applyToProductPage(conf);
    document.querySelectorAll('.cart-item').forEach(function (i) { applyToCartItem(i, conf); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
